import { SmartEnum } from '../../../../../primitives';
import {
  CustomExecutorActionTypeHandlerSmartEnum,
  DialogActionTypeHandlerSmartEnum,
  RedirectActionTypeHandlerSmartEnum
} from '../action-type-handlers';
import { ActionTypeHandlerBaseSmartEnum } from '../action-type-handlers/action-type-handler.enum';

export enum ActionTypeEnum {
  VIEW = 'View',
  CREATE = 'Create',
  UPDATE = 'Update',
  CUSTOM = 'Custom'
}

export class ActionTypeBaseSmartEnum extends SmartEnum<ActionTypeSmartEnum> {
  allowedHandlers: ActionTypeHandlerBaseSmartEnum[];
  defaultIcon: string;
  defaultLable: string;

  constructor(
    name: string,
    defaultIcon: string,
    defaultLable: string,
    allowedHandlers: ActionTypeHandlerBaseSmartEnum[]
  ) {
    super(name);
    this.allowedHandlers = allowedHandlers;
    this.defaultIcon = defaultIcon;
    this.defaultLable = defaultLable;
  }
}

export class ActionTypeSmartEnum extends ActionTypeBaseSmartEnum {
  public static View: ActionTypeSmartEnum = new ActionTypeSmartEnum(ActionTypeEnum.VIEW, 'pi pi-eye', 'ACTIONS.VIEW', [
    CustomExecutorActionTypeHandlerSmartEnum.CustomExecutor,
    DialogActionTypeHandlerSmartEnum.Dialog,
    RedirectActionTypeHandlerSmartEnum.Redirect
  ]);

  public static Update: ActionTypeSmartEnum = new ActionTypeSmartEnum(
    ActionTypeEnum.UPDATE,
    'pi pi-pen-to-square',
    'ACTIONS.EDIT',
    [
      CustomExecutorActionTypeHandlerSmartEnum.CustomExecutor,
      DialogActionTypeHandlerSmartEnum.Dialog,
      RedirectActionTypeHandlerSmartEnum.Redirect
    ]
  );

  public static Create: ActionTypeSmartEnum = new ActionTypeSmartEnum(
    ActionTypeEnum.CREATE,
    'pi pi-plus',
    'ACTIONS.CREATE_NEW_ITEM',
    [
      CustomExecutorActionTypeHandlerSmartEnum.CustomExecutor,
      DialogActionTypeHandlerSmartEnum.Dialog,
      RedirectActionTypeHandlerSmartEnum.Redirect
    ]
  );

  public static Custom: ActionTypeSmartEnum = new ActionTypeSmartEnum(ActionTypeEnum.CUSTOM, 'pi pi-plus', 'Custom', [
    CustomExecutorActionTypeHandlerSmartEnum.CustomExecutor,
    DialogActionTypeHandlerSmartEnum.Dialog,
    RedirectActionTypeHandlerSmartEnum.Redirect
  ]);

  constructor(
    name: string,
    defaultIcon: string,
    defaultLable: string,
    allowedHandlers: ActionTypeHandlerBaseSmartEnum[]
  ) {
    super(name, defaultIcon, defaultLable, allowedHandlers);
  }
}
